import PropTypes from 'prop-types';
import React from 'react';

import StandardSelect from 'app/components/common/standard-select';
import format         from 'app/helpers/format';

// const values = [0, 50, 75, 100, 150, 200, 225, 300];
const values = [0, 100, 200, 300, 400, 500];
const options = values.map((value) => {
  return {value, label: format.matchRatio(value)};
});
const optionsWAnnual = [
  {label: 'Use Annual Match Program Ratio', value: -1},
  ...options,
];



class MatchRatioSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(value) {
    this.props.onChange(value);
  }

  get options() {
    return this.props.showAnnualOpt ? optionsWAnnual : options;
  }

  render() {
    const {value, validations, name} = this.props;
    return (
      <StandardSelect
        options={this.options}
        value={value || 0}
        onSelect={this.onSelect}
        validations={validations}
        name={name}
      />
    );
  }
}

MatchRatioSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  showAnnualOpt: PropTypes.bool,
  validations: PropTypes.object,
  name: PropTypes.string,
};

MatchRatioSelector.defaultProps = {
  showAnnualOpt: false,
};

export default MatchRatioSelector;
